import script from "./AllLive.vue?vue&type=script&setup=true&lang=js"
export * from "./AllLive.vue?vue&type=script&setup=true&lang=js"

import "./AllLive.vue?vue&type=style&index=0&id=b9a4b746&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9a4b746"]])

export default __exports__